import { gql } from '@apollo/client';

export const GET_CLIENT_CARTON_BATCH_INBOUND_CHANNEL_OPTIONS = gql`
    query GetClientCartonBatchInboundChannelOptions {
        getClientCartonBatchInboundChannelOptions {
            channelId
            channelName
        }
    }
`;

export interface ClientCartonBatchInboundChannelOption {
    /** GraphQL Long 类型在 JSON 响应中序列化为字符串，使用时需 Number() 转换 */
    channelId: string;
    channelName: string;
}

export interface GetClientCartonBatchInboundChannelOptionsResponse {
    getClientCartonBatchInboundChannelOptions: ClientCartonBatchInboundChannelOption[];
}
